// Lightweight similarity detection for FAQ / Tutorial titles, so the admin
// gets a "similar existing item" warning while typing a new title. Uses
// Jaccard word-overlap — fast, no deps, intuitive for short titles.

function tokenize(s) {
    return new Set(
        (s || '')
            .toLowerCase()
            .replace(/[^\p{L}\p{N}\s]+/gu, ' ')  // strip punctuation, keep unicode letters/numbers
            .split(/\s+/)
            .filter(w => w.length >= 2),         // skip 1-char tokens like "a", "i"
    );
}

// Jaccard similarity: |A ∩ B| / |A ∪ B|. Range 0..1.
export function titleSimilarity(a, b) {
    const sa = tokenize(a), sb = tokenize(b);
    if (sa.size === 0 || sb.size === 0) return 0;
    let inter = 0;
    for (const w of sa) if (sb.has(w)) inter++;
    const union = sa.size + sb.size - inter;
    return union > 0 ? inter / union : 0;
}

// Returns up to `limit` candidates with the highest similarity to `title`,
// excluding the item identified by `excludeId` (so editing a row doesn't
// match itself). `threshold` is the minimum similarity ratio to surface.
//   items: [{ <idKey>, title }]
//   idKey: name of the unique id field on each item
export function findSimilarTitles(title, items, { idKey, excludeId = 0, threshold = 0.5, limit = 5 } = {}) {
    const trimmed = (title || '').trim();
    if (trimmed.length < 3) return [];
    const scored = [];
    for (const it of items) {
        if (excludeId && it[idKey] === excludeId) continue;
        const sim = titleSimilarity(trimmed, it.title);
        if (sim >= threshold) scored.push({ item: it, sim });
    }
    scored.sort((a, b) => b.sim - a.sim);
    return scored.slice(0, limit);
}
